import template from './print_master_cash_schedule.html';
import controller from './print_master_cash_schedule.controller';

let printMasterCashScheduleComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default printMasterCashScheduleComponent;



// WEBPACK FOOTER //
// ./client/app/components/master_cash_schedule/print/print_master_cash_schedule.component.js